export const GET_AUDIT_ACTIONS = 'GET_AUDIT_ACTIONS';
export const GET_AUDIT_LOG = 'GET_AUDIT_LOG';


// WEBPACK FOOTER //
// ./src/actions/auditLog/types.js